var React = require('react');

function EyeIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28 9C28 9 22.1783 16 15 16C7.82174 16 2 9 2 9C2 9 7.82174 2 15 2C22.1783 2 28 9 28 9Z","stroke":"#093248","strokeWidth":"3","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M15.054 13.9999C17.8154 13.9999 20.0419 11.7613 20.027 8.99993C20.0121 6.23854 17.7614 4 15 4C12.2386 4 10.0121 6.23854 10.027 8.99993C10.0419 11.7613 12.2926 13.9999 15.054 13.9999Z","fill":"#093248","stroke":"#093248","strokeWidth":"3","strokeMiterlimit":"10","key":1})]);
}

EyeIcon.defaultProps = {"width":"30","height":"18","viewBox":"0 0 30 18","fill":"none"};

module.exports = EyeIcon;

EyeIcon.default = EyeIcon;
